module.exports = __webpack_public_path__ + "static/media/elDesafio.b5950e3d.webp";